import React from 'react';
import { Route, Routes } from 'react-router-dom';
import RightsAndPrivacyPage from './policy/rightsandprivacy';
import AboutPage, { AboutAnalyticsPage, AboutCookiesPage } from './login/about';
import WelcomePage from './login/welcome';

const TopRoutesUnauthenticated = () => {
  return (
    <Routes>
      <Route path="/about" element={<AboutPage />} />
      <Route path="/rightsandprivacy" element={<RightsAndPrivacyPage />} />
      <Route path="/cookies" element={<AboutCookiesPage />} />
      <Route path="/analytics" element={<AboutAnalyticsPage />} />
      <Route path="/*" element={<WelcomePage />} />
    </Routes>
  );
};

export default TopRoutesUnauthenticated;
